export const CHECKOUT_ERRORS = {
    DECLINED: 'DECLINED',
    GENERIC: 'GENERIC',
    NotSpecifiedShippingOption: 'NotSpecifiedShippingOption',
    NO_PAYMENT_METHOD: 'No payment method is available.',
    CANCELLED: 'Cancelled',
};

const CHECKOUT_ERROR_STRINGS = {
    [CHECKOUT_ERRORS.DECLINED]: 'checkout_summary_error_declined',
    [CHECKOUT_ERRORS.GENERIC]: 'checkout_summary_error',
    [CHECKOUT_ERRORS.NotSpecifiedShippingOption]:
        'checkout_summary_error_shipping_non_spec',
    [CHECKOUT_ERRORS.NO_PAYMENT_METHOD]:
        'checkout_summary_error_no_payment_method',
    // Possible error codes from backend
    ['Error']: 'checkout_summary_error',
    ['Declined']: 'checkout_summary_error_declined',
    ['InsufficientFunds']: 'checkout_summary_error_insufficient_funds',
    ['PaymentInstrumentTypeNotAccepted']:
        'checkout_summary_error_payment_intrument_type_not_accepted',
};

type CheckoutErrorMessage = keyof typeof CHECKOUT_ERRORS;

export const getCheckoutErrorMessage = (type: CheckoutErrorMessage) => {
    return (
        CHECKOUT_ERROR_STRINGS[type] ||
        CHECKOUT_ERROR_STRINGS[CHECKOUT_ERRORS.GENERIC]
    );
};
